import { render, staticRenderFns } from "./data-sync.vue?vue&type=template&id=54ddfc18&scoped=true"
import script from "./data-sync.vue?vue&type=script&lang=js"
export * from "./data-sync.vue?vue&type=script&lang=js"
import style0 from "./data-sync.vue?vue&type=style&index=0&id=54ddfc18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddfc18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ddfc18')) {
      api.createRecord('54ddfc18', component.options)
    } else {
      api.reload('54ddfc18', component.options)
    }
    module.hot.accept("./data-sync.vue?vue&type=template&id=54ddfc18&scoped=true", function () {
      api.rerender('54ddfc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/data-sync.vue"
export default component.exports